export enum ReportType {
    Undefined = 0,
    Public = 1,
    Internal = 2,
    Detail = 3,
    CustomFunction = 4,
    FrontendDataSource = 5
}
